/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';

    /**
     * Factory callback type
     */
    declare type StatusTagDirectiveFactoryCb = () => StatusTagDirective;

    /**
     * Custom scope
     */
    export interface IStatusTagDirectiveScopeDef {
        model: string;
        id: string;
    }

    /**
     * Custom scope
     */
    export interface IStatusTagDirectiveScope extends ng.IScope {
        model: string;
        id: string;
        status: string;
        empty: boolean;
    }

    /**
     * Bar directive
     */
    export class StatusTagDirective implements ng.IDirective {
        public static $name: string = "statusTag";
        public static $inject: string[] = [];
        
        public link: (scope: IStatusTagDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'AE';
        public transclude: boolean = false;
        public templateUrl: string = 'decorators/status-tag-directive.html';
        public scope: IStatusTagDirectiveScopeDef = {
            model: '=',
            id: '@',
        };

        /**
         * Factory for the directive
         */
        public static Factory(): StatusTagDirectiveFactoryCb {
            let directive: StatusTagDirectiveFactoryCb = () => {
                return new StatusTagDirective();
            };
            return directive;
        }

        /**
         * Constructor
         */
        constructor() {
            StatusTagDirective.prototype.link = (scope: IStatusTagDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {
                if (attrs.$attr.hasOwnProperty('empty')) {
                    scope.empty = true;
                }
                
                scope.status = this.getStatus(scope.model);
                scope.$watchGroup(['model', 'id'], (newValues: [string, string], oldValues: [string, string]) => {
                    scope.status = this.getStatus(scope.model);
                    let newStatus: string = newValues[0];
                    let oldStatus: string = oldValues[0];
                    let newId: string = newValues[1];
                    let oldId: string = oldValues[1];
                    if ((oldId === undefined || newId === oldId) && newStatus !== oldStatus) {
                        let parsedId: string = scope.id.split('/').join('\\\/')
                                                       .split(' ').join('\\\ ');
                        let badgeWrapper: JQuery = jQuery('#badge-' + parsedId);
                        let bounceStep: number = 5;
                        let animationStep: number = 100;
                        jQuery(badgeWrapper)
                            .animate({ top: bounceStep }, animationStep)
                            .animate({ top: 0}, animationStep)
                            .animate({ top: bounceStep }, animationStep)
                            .animate({ top: 0}, animationStep)
                            .animate({ top: bounceStep }, animationStep)
                            .animate({ top: 0}, animationStep);
                    }
                });
            };
        }

        /**
         * Return color style depending on 'model' string
         */
        private getStatus (model: string): string {
            if (model === 'FAILING' || model === 'OFFLINE' || model === 'LIVE') {
                return 'ALERT';
            } else if (model === 'PASSED' || model === 'ONLINE') {
                return 'SUCCESS';
            } else if (model === 'NOT_CHECKED' || model === 'PENDING') {
                return 'WARNING';
            } else if (model === 'DISABLED') {
                return 'DISABLED';
            } else {
                return '';
            }
        }
    }
}
